var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3475 14.8675C3.47725 14.9977 3.57667 15.155 3.63868 15.3281C3.70069 15.5011 3.72376 15.6857 3.70625 15.8687C3.6184 16.7157 3.45185 17.5527 3.20875 18.3687C4.9525 17.965 6.0175 17.4975 6.50125 17.2525C6.77563 17.1135 7.09161 17.0806 7.38875 17.16C8.24054 17.3871 9.11846 17.5014 10 17.5C14.995 17.5 18.75 13.9913 18.75 10C18.75 6.01 14.995 2.5 10 2.5C5.005 2.5 1.25 6.01 1.25 10C1.25 11.835 2.02125 13.5375 3.3475 14.8675ZM2.73125 19.7487C2.43509 19.8075 2.13796 19.8612 1.84 19.91C1.59 19.95 1.4 19.69 1.49875 19.4575C1.60974 19.1957 1.71147 18.9302 1.80375 18.6612L1.8075 18.6487C2.1175 17.7487 2.37 16.7138 2.4625 15.75C0.92875 14.2125 0 12.2 0 10C0 5.1675 4.4775 1.25 10 1.25C15.5225 1.25 20 5.1675 20 10C20 14.8325 15.5225 18.75 10 18.75C9.00956 18.7513 8.02323 18.6227 7.06625 18.3675C6.41625 18.6963 5.0175 19.295 2.73125 19.7487Z",
    fill: "#008CB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.44ce5c9f123c59434742fc7b141df91f.svg";
export { ForwardRef as ReactComponent };